import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FattureState } from './fatture.reducer';

export const selectFattureState = createFeatureSelector<FattureState>('fatture');

export const selectList       = createSelector(selectFattureState, s => s.items);
export const selectLoading    = createSelector(selectFattureState, s => s.loading);
export const selectError      = createSelector(selectFattureState, s => s.error);

export const selectSelected   = createSelector(selectFattureState, s => s.selected);
export const selectOpLoading  = createSelector(selectFattureState, s => s.opLoading);
export const selectOpError    = createSelector(selectFattureState, s => s.opError);

export const selectTotalElements = createSelector(selectFattureState, s => s.totalElements);
export const selectTotalPages    = createSelector(selectFattureState, s => s.totalPages);
export const selectPageIndex     = createSelector(selectFattureState, s => s.pageIndex);
export const selectPageSize      = createSelector(selectFattureState, s => s.pageSize);
export const selectLastQuery     = createSelector(selectFattureState, s => s.lastQuery);

export const selectSdiItems = createSelector(selectFattureState, s => s.sdiItems);
export const selectSdiLoading = createSelector(selectFattureState, s => s.sdiLoading);
export const selectSdiError = createSelector(selectFattureState, s => s.sdiError);
export const selectSdiImporting = createSelector(selectFattureState, s => s.sdiImporting);
